import CasePageUIMenu from './CasePageUIMenu'

export default CasePageUIMenu
